/* eslint-disable @typescript-eslint/naming-convention */
/**
 * Array backed Enumerable
 */
export class ArrayEnumerable extends Array {
}
